import React from 'react'

import { useRemoteStrings } from '@acorns/web-utils'

import { useBlueprintBindings } from '../utils/blueprint-bindings-context'
import type { GroveBlueprintComponentProps } from '../utils/grove-blueprint-component-props'
import { resolveModifiers } from '../utils/resolve-modifiers'

export function GroveBlueprintSpacer({ node }: GroveBlueprintComponentProps) {
  const { getRemoteString } = useRemoteStrings()
  const { bindingValues } = useBlueprintBindings()

  /* v8 ignore if -- @preserve */
  if (node.type !== 'Spacer') {
    return null
  }

  const { className, style, attributes } = resolveModifiers(
    node.modifiers,
    bindingValues,
    (key: string) => getRemoteString({ key }),
  )

  return (
    <div
      className={`flex-1 ${className}`.trim()}
      style={style}
      {...attributes}
    />
  )
}
